import { AgentSessionTypes } from '../Stores/useAgent'
import { SESSION_STORAGE } from '../constants/sessionStorage'

export function parseAgentFromPortal(contextSelectedArray: AgentSessionTypes) {
  if (contextSelectedArray) {
    if (contextSelectedArray?.[0].includes('Agent')) {
      return contextSelectedArray?.[1].replace(/["']/g, '')
    } else {
      const agentContextId = sessionStorage.getItem(
        SESSION_STORAGE.NPAAgentContextID,
      )
      if (agentContextId) {
        return agentContextId
      }
    }
  }

  return null
}
